import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './features25.css'

const Features25 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="features25-container2 thq-section-max-width">
        <div className="features25-tabs-menu">
          <div className="features25-tab-horizontal1">
            <div className="features25-divider-container1">
              <div className="features25-container3"></div>
            </div>
            <div className="features25-content1">
              <h2 className="thq-heading-2">
                {props.feature1Title ?? (
                  <Fragment>
                    <span className="features25-text2">
                      Personalized Training Programs
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {props.feature1Description ?? (
                  <Fragment>
                    <span className="features25-text1">
                      Each client receives a customized training program
                      tailored to their fitness goals and abilities.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="features25-tab-horizontal2">
            <div className="features25-divider-container2">
              <div className="features25-container4"></div>
            </div>
            <div className="features25-content2">
              <span className="thq-body-small">
                {props.feature2Description ?? (
                  <Fragment>
                    <span className="features25-text3">
                      Get expert advice on nutrition to complement your training
                      and optimize your results.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className="features25-tab-horizontal3">
            <div className="features25-divider-container3">
              <div className="features25-container5"></div>
            </div>
            <div className="features25-content3">
              <span className="thq-body-small">
                {props.feature3Description ?? (
                  <Fragment>
                    <span className="features25-text4">
                      Ongoing support to keep your training consistent and
                      progressing.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="features25-image-container">
          <img
            alt={props.feature1ImgAlt}
            src={props.feature1ImgSrc}
            className="special-img-3 thq-img-ratio-16-9"
          />
        </div>
      </div>
    </div>
  )
}

Features25.defaultProps = {
  feature1Description: undefined,
  feature1ImgAlt: 'Personalized Training Programs Image',
  feature1Title: undefined,
  feature1ImgSrc:
    'https://images.unsplash.com/photo-1519505907962-0a6cb0167c73?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDQxfHxmaXRuZXNzfGVufDB8fHx8MTcyOTQwNjc4OXww&ixlib=rb-4.0.3&w=1400',
  feature2Description: undefined,
  feature3Description: undefined,
}

Features25.propTypes = {
  feature1Description: PropTypes.element,
  feature1ImgAlt: PropTypes.string,
  feature1Title: PropTypes.element,
  feature1ImgSrc: PropTypes.string,
  feature2Description: PropTypes.element,
  feature3Description: PropTypes.element,
}

export default Features25
